import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

import { Badge } from "react-bootstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';

import { api } from "../../services/Api";

import './index.css';

import { AuthContext } from '../../store/AuthContext';
import { AlertaExpedicaoContext } from "../AlertaExpedicao/contextsAlerta/AlertaExpedicao";
import alertaFileDownload from "../AlertaFileDownload/alertaFileDownload";

import EctCaixaAberta from '../../assets/img/caixa-aberta-cor.svg';
import EctCaixaFechada from '../../assets/img/caixa-cor.svg';

import ToastCustomizado from "../../components/Toast";
import { HOJE, VENCER, VENCIDO } from "../../pages/AlertaExpedicao/utils/Constants";
import { Constants } from "../../util/Constants";
import { Mensagem } from "../AlertaExpedicao/utils/mensagem";
import { dataAtualFormatada, validaExisteOMenu } from './../../util/FuncoesComuns';



const Home = () => {

  const [ show, setShow ] = useState<boolean>(false);
  const [ isLinkDisabled, setIsLinkDisabled ] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-expedicao' });
  const [ qtdListasOec, setQtdListasOec ] = useState<any>(null);
  const { user, login, menusEUnidadeSro } = useContext(AuthContext);
  const { setKey, resumoAlerta, setResumoAlerta } = useContext(AlertaExpedicaoContext); //useState<IPreAlertaResumo[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    setKey(()=>'resumo')
    if (user && Object.keys(user).length > 0 && login && user.unidadeSro && user.unidadeSro.codigoSro) {

      (async function () {

        if(!user.unidadeSro) await menusEUnidadeSro(true);
        const [lista,listaLoec] = await Promise.allSettled([
              api.get(`/v1/expedicoes-pre-alertas/resumo/${user?.unidadeSro.codigoSro}`),
              api.get(`/v1/resumo-diario-oec/quantidade?codSroOrigem=${user?.unidadeSro.codigoSro}&dataListasOec=${dataAtualFormatada('ano','-')}`)
      ]);

        if (lista.status === 'fulfilled') {

          setResumoAlerta(() => lista.value.data);
          setShow(()=>(lista.value.data && lista.value.data.length > 0 && login && (lista.value.data[0]?.qtdUnitizadores > 0 || lista.value.data[0]?.qtdObjetosPendentes > 0 || lista.value.data[0]?.qtdObjetosFaltantes > 0)));

        } else {
          setResumoAlerta(() => []);
          setShow(()=> false);
        }

        if (listaLoec.status === 'fulfilled') {
          setQtdListasOec(() => listaLoec.value.data[0]);
        } else {
          setQtdListasOec(() => null);
        }

      })();
      navigate("/");
    }else{
      setResumoAlerta(() => []);
      setQtdListasOec(() => null);
      setShow(()=> false);
    }
    if (!user || Object.keys(user).length === 0 || !login) {
      setShow(()=> false);
      login ? navigate("/") : navigate('login');
    }

    setIsLinkDisabled(() => user?.unidadeSro?.nome?.startsWith('CT') || (user && !user.isTemMenus));
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (

    <>


      <Breadcrumb>
          <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
      </Breadcrumb>
      <Row>
        <Col lg={3} md={6}>
          {
            (show) ?
              (
                <>
                  <Card>
                    <Card.Img className="image-cards-resumo" variant="top" src={EctCaixaAberta} alt="Caixa Aberta" />
                    <Card.Body className="card-body pt-0">
                      <Card.Title className="text-center"><h4><Link className="text-center" key='1' to={'/alerta-expedicao'}>Alerta Expedição</Link></h4></Card.Title>
                      <Table responsive="sm striped mt-1 mb-0 pb-0 margin-bottom table-cars-border" size="sm" className="text-center">
                        <thead className="">
                          <tr>
                            <th rowSpan={1} colSpan={5} className="align-middle">{resumoAlerta[0]?.qtdObjetosPendentes + resumoAlerta[0]?.qtdObjetosFaltantes} Iten(s) em {resumoAlerta[0]?.qtdUnitizadores} Unitizador(es)</th>
                          </tr>
                          <tr>
                            <th rowSpan={2} className="align-middle">Pendente(s)</th>
                            <th rowSpan={2} className="border-end align-middle">Faltante(s)</th>
                            <th rowSpan={1} colSpan={3} className="align-middle">Prazo Entrega</th>
                          </tr>
                          <tr>
                            <th>Vencido(s)</th>
                            <th>Hoje</th>
                            <th>Vencer</th>
                          </tr>
                        </thead>
                        <tbody className="pb-0">
                          <tr>
                            <td>{resumoAlerta[0]?.qtdObjetosPendentes}</td>
                            <td className="border-end">{resumoAlerta[0]?.qtdObjetosFaltantes}</td>
                            <td className="text-danger"><Badge bg="danger" className="ms-1"><Link to="/" className={`text-white ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-expedicao') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.RO, situacaoAlerta: VENCIDO}, setMensagem, setShowToast)}>{resumoAlerta[0]?.qtdObjetosPrazoMaximoVencido}</Link></Badge></td>
                            <td className="text-warning"><Badge bg="warning" className="ms-1"><Link to="/" className={`text-dark ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-expedicao') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.RO, situacaoAlerta: HOJE}, setMensagem, setShowToast)}>{resumoAlerta[0]?.qtdObjetosPrazoMaximoHoje}</Link></Badge></td> 
                            <td className="text-success"><Badge bg="success" className="ms-1"><Link to="/" className={`text-white ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-expedicao') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.RO, situacaoAlerta: VENCER}, setMensagem, setShowToast)}>{resumoAlerta[0]?.qtdObjetosPrazoMaximoVencer}</Link></Badge></td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card.Body>
                    <Row className="mt-0 mb-2">
                      <Link className={`text-center ${user && user.isTemMenus && validaExisteOMenu(user?.menus, '/alerta-expedicao') ? '' : ' text-decoration-line-through disabled-link'}`} key='1' to={'/alerta-expedicao'}>Clique aqui</Link>
                    </Row>
                  </Card>
                </>
              )
              :

              (
                <>
                  <Card>
                    <Card.Img className="image-cards-resumo" variant="top" src={EctCaixaAberta} alt="Caixa Aberta" />
                    <Card.Body className="card-body pt-0 pb-5">
                      <Card.Title className="text-center"><h4>Alerta Expedição</h4></Card.Title>
                      <ListGroup.Item className="align-middle text-center pt-4 mt-3"><h5>Não existe Alerta Expedição</h5></ListGroup.Item>
                    </Card.Body>
                    <Row className="mt-0 mb-2">
                      <br/><br/>
                    </Row>
                  </Card>
                </>


              )
          }
        </Col>
        <Col lg={3} md={6}>
          {
            (qtdListasOec) ?
            (
              <>
                <Card>
                  <Card.Img className="image-cards-resumo" variant="top" src={EctCaixaAberta} alt="Caixa Aberta" />
                  <Card.Body className="card-body pt-0">
                    <Card.Title className="text-center"><h4><Link className="text-center" key='1' to={'/alerta-expedicao'}>Alerta LOEC</Link></h4></Card.Title>
                    <Table responsive="sm striped mt-1 mb-0 pb-0 margin-bottom table-cars-border" size="sm" className="text-center">
                      <thead className="">
                        <tr>
                          <th rowSpan={1} colSpan={6}>{qtdListasOec.qtdItensOec} Itens em {qtdListasOec.qtdListasOec} Listas. ({qtdListasOec.qtdListasOecCargaSmartphone} carregadas Smartphones.)</th>
                        </tr>
                        <tr>
                            <th rowSpan={2} className="align-middle">BDE</th>
                            <th rowSpan={2} className="border-end align-middle">BDR</th>
                            <th rowSpan={1} colSpan={3} className="align-middle">Prazo Entrega</th>
                          </tr>
                        <tr>
                          <th>Vencido(s)</th>
                          <th>Hoje</th>
                          <th>Vencer</th>
                        </tr>
                      </thead>
                      <tbody className="pb-0">
                        <tr>
                          <td>{qtdListasOec.qtdItensBde}</td>
                          <td className="border-end">{qtdListasOec.qtdItensBdr}</td>
                          <td className="text-danger"><Badge bg="danger" className="ms-1"><Link to="/" className={`text-white ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-loec') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.OEC, situacaoAlerta: VENCIDO}, setMensagem, setShowToast)}>{qtdListasOec?.qtdObjetosPrazoMaximoVencido}</Link></Badge></td>
                          <td className="text-warning"><Badge bg="warning" className="ms-1"><Link to="/" className={`text-dark ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-loec') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.OEC, situacaoAlerta: HOJE}, setMensagem, setShowToast)}>{qtdListasOec?.qtdObjetosPrazoMaximoHoje}</Link></Badge></td>
                          <td className="text-success"><Badge bg="success" className="ms-1"><Link to="/" className={`text-white ${isLinkDisabled || !validaExisteOMenu(user?.menus, '/alerta-loec') ? ' disabled-link' : ''}`} onClick={()=>alertaFileDownload({codSroOrigem: user?.unidadeSro.codigoSro, tipoAlerta: Constants.OEC, situacaoAlerta: VENCER}, setMensagem, setShowToast)}>{qtdListasOec?.qtdObjetosPrazoMaximoVencer}</Link></Badge></td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                  <Row className="mt-0 mb-2">
                    <Link className={`text-center ${user && user.isTemMenus && validaExisteOMenu(user?.menus, '/alerta-loec') ? '' : ' text-decoration-line-through disabled-link'}`} key='1' to={'/alerta-loec'}>Clique aqui</Link>
                  </Row>
                </Card>
              </>
            )

            :

            (
              <>
                <Card>
                <Card.Img className="image-cards-resumo" variant="top" src={EctCaixaFechada} alt="Caixa Fechada" />
                  <Card.Body className="card-body pt-0 pb-5">
                    <Card.Title className="text-center"><h4>Alerta LOEC</h4></Card.Title>
                    <ListGroup.Item className="align-middle text-center pt-4 mt-3"><h5>Não existe Alerta LOEC</h5></ListGroup.Item>
                  </Card.Body>
                  <Row className="mt-0 mb-2">
                            <br/><br/>
                          </Row>
                </Card>
            </>
            )
          }
        </Col>
      </Row>

      <div className="home">
        <br />
        <br />
        <br />
        <br />
        <p>
          ATENÇÃO: Utilize o navegador Google Chrome versão igual ou maior que 100.
        </p>
      </div>

{ showToast ?
            <ToastCustomizado
              show={showToast}
              setShow={setShowToast}
              mensagem={mensagem && mensagem.texto ? mensagem.texto : undefined}
              tipo={mensagem && mensagem.tipo ? mensagem.tipo : ''}
              delay={mensagem?.delay}
            />
            : null }

    </>

  );
}

export default Home